<template>
  <div
    class="rounded-small shadow-1 absolute right-0 bottom-0 flex h-5 w-5 items-center justify-center"
    :class="[
      (type == 'to' || type == 'self') && 'bg-tertiary text-on-tertiary',
      type == 'from' && 'bg-primary text-on-primary',
    ]"
  >
    <BaseIcon size="18" :filled="true">{{ icon }}</BaseIcon>
  </div>
</template>
<script lang="ts" setup>
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import { computed } from 'vue'

  interface Props {
    type: 'to' | 'from' | 'self'
  }

  const props = defineProps<Props>()

  const icon = computed(() => {
    if (props.type === 'to') {
      return 'arrow_left_alt'
    } else if (props.type === 'from') {
      return 'arrow_right_alt'
    } else {
      return 'undo'
    }
  })
</script>
